import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ErisLoginService} from './eris-login.service';
import {AccountService} from '../account.service';

@Injectable({
  providedIn: 'root'
})
export class ErisLoginGuard implements CanActivateChild {
  constructor(private authorize: ErisLoginService, private router: Router, private accountService: AccountService) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize.isAuthenticated()
      .pipe(tap(isAuthenticated => this.handleAuthorization(isAuthenticated, state)));
  }

  private handleAuthorization(isAuthenticated: boolean, state: RouterStateSnapshot) {
    if (!isAuthenticated) {
      this.accountService.removeData();
      this.router.navigateByUrl(`login?returnUrl=${state.url}`);
    }
  }
}
